import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Make, VehicleModel, VehicleType } from '../models/vehicle.model';

@Injectable({ providedIn: 'root' })
export class VehicleCatalogService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  getMakes(): Observable<Make[]> {
    return this.http.get<Make[]>(`${this.baseUrl}/makes`);
  }

  getVehicleTypes(makeId: number): Observable<VehicleType[]> {
    return this.http.get<VehicleType[]>(`${this.baseUrl}/makes/${makeId}/vehicle-types`);
  }

  getModels(makeId: number, year: number, vehicleType: string): Observable<VehicleModel[]> {
    return this.http.get<VehicleModel[]>(`${this.baseUrl}/models`, {
      params: { makeId, year, vehicleType },
    });
  }
}
